import { Link } from "react-router";

export function Logo({ to = "/", compact = false }: { to?: string; compact?: boolean }) {
  return (
    <Link to={to} className="flex items-center gap-2 font-semibold tracking-tight text-fg" aria-label="DBIndex home">
      <svg viewBox="0 0 32 32" className="size-6" aria-hidden>
        <rect width="32" height="32" rx="7" fill="var(--panel-2)" />
        <path d="M9 8h7a8 8 0 0 1 0 16H9z" fill="none" stroke="var(--accent)" strokeWidth="3" />
        <circle cx="16" cy="16" r="2.5" fill="var(--accent)" />
      </svg>
      {!compact && (
        <span>
          DBIndex<span className="text-fg-3">.ai</span>
        </span>
      )}
    </Link>
  );
}
